import {
  WSCard,
  WSElement,
  WSIcon,
  WSList,
  WSText,
  WSTodoList
} from "@wingspanhq/fe-component-library";
import React from "react";
import { useHistory } from "react-router-dom";
import { PATH_ONBOARDING_TAX_WITHHOLDINGS } from "../../Onboarding";
import { useIsTaxWithholdingsSetupComplete } from "../hooks/useIsTaxWithholdingsSetupComplete";

export const PreviewInstructions: React.FC = () => {
  const history = useHistory();

  const setupComplete = useIsTaxWithholdingsSetupComplete();

  return (
    <WSCard
      divider
      actions={
        setupComplete
          ? undefined
          : {
              alignment: "left",
              buttons: [
                {
                  label: "Setup tax withholdings",
                  rightIcon: "chevron-right",
                  onClick: () => {
                    history.push(PATH_ONBOARDING_TAX_WITHHOLDINGS);
                  },
                  kind: "Link"
                }
              ]
            }
      }
    >
      <WSList gap="XL">
        <WSElement>
          <WSIcon block mb="L" name="calculator" size="M" color="gray600" />
          <WSText.Heading5>Set aside money for taxes</WSText.Heading5>
          <WSText.ParagraphSm color="gray500">
            Automate tax withholdings with Wingspan
          </WSText.ParagraphSm>
        </WSElement>

        <WSTodoList
          items={[
            {
              mark: "1.",
              content: (
                <>
                  <WSText.ParagraphSm weight="medium">
                    Estimate your tax rate
                  </WSText.ParagraphSm>
                  <WSText.ParagraphSm mt="XS">
                    Find our recommendation specific to you
                  </WSText.ParagraphSm>
                </>
              )
            },
            {
              mark: "2.",
              content: (
                <>
                  <WSText.ParagraphSm weight="medium">
                    Start setting aside
                  </WSText.ParagraphSm>
                  <WSText.ParagraphSm mt="XS">
                    Automatically set aside your tax rate from all Wingspan
                    payments
                  </WSText.ParagraphSm>
                </>
              )
            },
            {
              mark: "3.",
              content: (
                <>
                  <WSText.ParagraphSm weight="medium">
                    Watch your withholdings grow
                  </WSText.ParagraphSm>
                  <WSText.ParagraphSm mt="XS">
                    Wingspan holds your tax withholdings, withdraw when you
                    need!
                  </WSText.ParagraphSm>
                </>
              )
            },
            {
              mark: "4.",
              content: (
                <>
                  <WSText.ParagraphSm weight="medium">
                    Pay the IRS
                  </WSText.ParagraphSm>
                  <WSText.ParagraphSm mt="XS">
                    Send 1-click payments on time each quarter
                  </WSText.ParagraphSm>
                </>
              )
            }
          ]}
        />
      </WSList>
    </WSCard>
  );
};
